"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookmarkOutlined = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var BookmarkOutlined = function () {
    return (react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M6 2h12a2 2 0 012 2v17a1 1 0 01-1.53.85l-5.94-3.72a1 1 0 00-1.06 0l-5.94 3.72A1 1 0 014 21V4a2 2 0 012-2zm12 17.19V4H6v15.19l4.41-2.75a3 3 0 013.18 0L18 19.19z", clipRule: "evenodd" }));
};
exports.BookmarkOutlined = BookmarkOutlined;
//# sourceMappingURL=bookmark-outlined.js.map